module.exports = __webpack_public_path__ + "static/img/footer.524e4e74.jpg";